<template>
  <LoaderView v-if="!isLoggedIn" />
  <Inactive v-else-if="!isConfirmed" />
  <MesPreferences v-else-if="!hasInfo" />

  <div v-else class="consumer-space-layout">
    <!-- Burger menu bouton visible uniquement sur mobile -->
    <button class="burger-menu" @click="menuOpen = true">
      <font-awesome-icon :icon="['fas', 'bars']" />
    </button>

    <!-- Barre du haut (mobile only) -->
    <div class="topbar">
      <button class="burger-menu" @click="menuOpen = true">
        <font-awesome-icon :icon="['fas', 'bars']" />
      </button>
    </div>

    <!-- Overlay (cliquable pour fermer le menu) -->
    <div v-if="menuOpen" class="overlay" @click="menuOpen = false"></div>

    <!-- Menu latéral -->
    <div class="consumer-space-navbar" :class="{ open: menuOpen }">
      <div class="navbar-header">
        <router-link to="/" @click="menuOpen = false">
          <img class="img-logo" src="../assets/app/logo-version-allongee-baseline-couleur.png" alt="Logo" />
        </router-link>
        <button class="close-menu" @click="menuOpen = false">
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
      </div>

      <div class="consumer-space-name">Bienvenue {{ name }}</div>

      <div class="consumer-space-menu">
        <router-link v-if="hasPat" class="consumer-space-menu-item" to="/actualites-pat" active-class="active"
          @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'shopping-basket']" />
          Mes actualités locales
        </router-link>

        <div class="consumer-space-menu-spacer"></div>

        <router-link class="consumer-space-menu-item" to="/mes-menus" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'utensils']" />
          Mes menus
        </router-link>

        <router-link class="consumer-space-menu-item" to="/recettes/" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'heart']" />
          Mes recettes
        </router-link>

        <router-link class="consumer-space-menu-item" to="/mes-courses" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'shopping-basket']" />
          Mes courses
        </router-link>

        <router-link class="consumer-space-menu-item" to="/mes-apports-nutritionnels" active-class="active"
          @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'apple-alt']" />
          Mes apports nutritionnels
        </router-link>

        <div class="consumer-space-menu-spacer"></div>

        <div class="consumer-space-menu-item" @click="regenerateMenus">
          <Loader v-if="regenerateMenusLoading" />
          <font-awesome-icon v-else class="icon" :icon="['fas', 'lock']" />
          Regénérer mes menus
        </div>

        <router-link class="consumer-space-menu-item" to="/mes-preferences" active-class="active"
          @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'tools']" />
          Mes préférences
        </router-link>

        <router-link class="consumer-space-menu-item" to="/mode-demploi" active-class="active"
          @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'tools']" />
          Mode d'emploi
        </router-link>

        <div class="consumer-space-menu-spacer"></div>

        <router-link class="consumer-space-menu-item" to="/un-algorithme-de-personnalisation-alimentaire"
          active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'brain']" />
          Mon algorithme
        </router-link>

        <router-link class="consumer-space-menu-item" to="/mes-meilleurs-menus-au-quotidien" active-class="active"
          @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'calendar-day']" />
          Mes Meilleurs Menus au quotidien
        </router-link>

        <div class="consumer-space-menu-spacer"></div>

        <router-link class="consumer-space-menu-item" to="/mon-compte" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'user']" />
          Mon compte
        </router-link>

        <router-link class="consumer-space-menu-item" to="/deconnection" active-class="active"
          @click="menuOpen = false">
          <font-awesome-icon class="icon" :icon="['fas', 'sign-out-alt']" />
          Déconnexion
        </router-link>
      </div>
    </div>

    <router-view style="flex: 1;" />
  </div>
</template>

<script>
import { userState } from "@/utils/store";
import LoaderView from "@/components/LoaderView.vue";
import Inactive from "@/views/Inactive.vue";
import MesPreferences from "@/views/MesPreferences.vue";
import { api } from "@/api";
import Loader from "@/components/Loader.vue";

export default {
  name: "ConsumerSpaceLayout",
  components: {
    LoaderView,
    Inactive,
    MesPreferences,
    Loader,
  },
  data() {
    return {
      regenerateMenusLoading: false,
      menuOpen: false,
    };
  },
  computed: {
    isStaff() {
      return userState.me?.is_staff ?? null;
    },
    name() {
      return userState.me?.consumer_account?.consumers?.[0]?.name ?? "";
    },
    isLoggedIn() {
      return userState.isLoggedIn();
    },
    isConfirmed() {
      return true;
    },
    hasInfo() {
      return true;
    },
    hasPat() {
      return userState.me?.has_pat === true;
    },
  },
  mounted() {
    if (!this.isLoggedIn) {
      userState.recoverAuth().catch(() => {
        // si tokens invalides => redirection login (évite écran blanc)
        this.$router.replace("/connection");
      });
    }
  },
  methods: {
    regenerateMenus() {
      this.regenerateMenusLoading = true;
      api.post("/regenerate-my-menus/").then(() => {
        window.location.reload();
      });
    },
  },
};
</script>

<style scoped>
.consumer-space-layout {
  display: flex;
  flex: 1;
  position: relative;
}

.consumer-space-navbar {
  width: 260px;
  min-width: 260px;
  max-width: 260px;
  background: #192704;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 20;
  transition: transform 0.3s ease-in-out;

  /* ✅ scroll interne */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.consumer-space-name {
  font-family: "Amanise";
  font-weight: 500;
  font-size: 30px;
  padding: 10px;
  color: #77af24;
}

.consumer-space-menu {
  display: flex;
  flex-direction: column;
}

.consumer-space-menu-item {
  color: #9da5ae;
  text-decoration: none;
  font-size: 18px;
  padding: 7px 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 1;
}

.consumer-space-menu-spacer {
  height: 20px;
}

.consumer-space-menu-item.active {
  color: #77af24;
}

.consumer-space-menu-item:hover {
  color: #77af24;
}

.img-logo {
  width: 100%;
}

.burger-menu {
  display: none;
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 30;
  background: none;
  border: none;
  font-size: 24px;
  color: #ffffff;
  cursor: pointer;
}

.close-menu {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: white;
  margin-left: auto;
  cursor: pointer;
}

.overlay {
  display: none;
}

@media (max-width: 768px) {
  .consumer-space-navbar {
    position: fixed;

    /* ✅ IMPORTANT : on se met sous la topbar */
    top: 50px;

    /* ✅ IMPORTANT : hauteur restante sous la topbar */
    height: calc(100vh - 50px);

    left: 0;
    transform: translateX(-100%);

    /* ✅ IMPORTANT : espace bas pour voir le dernier item */
    padding-bottom: calc(40px + env(safe-area-inset-bottom));
  }

  .consumer-space-navbar.open {
    transform: translateX(0);
  }

  .burger-menu {
    display: block;
  }

  .close-menu {
    display: block;
  }

  .overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
}

.topbar {
  display: none;
}

/* Affichée uniquement sur mobile */
@media (max-width: 768px) {
  .topbar {
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 15px;
    background-color: #192704;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 30;
  }

  .burger-menu {
    display: block;
    font-size: 24px;
    color: #ffffff;
    background: none;
    border: none;
    cursor: pointer;
  }

  .consumer-space-layout {
    padding-top: 50px;
  }
}
</style>
